import { Avatar, Stack, Typography } from "@mui/joy";
import TitleWithSubtitle from "components/common/TitleWithSubtitle";
import { useTranslation } from "react-i18next";
import Link from "components/common/Link";
import { useRecoilValue } from "recoil";
import { localizationAtom } from "recoil/localizationAtom";

export default function Reviews() {
  const locale = useRecoilValue(localizationAtom);
  const isKo = locale.includes("ko");

  const { t: t_payment } = useTranslation("translation", {
    keyPrefix: "payment",
  });

  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });

  const data: { text: string; from: string; link: string }[] = [
    {
      text: "스스로를 이해하고 한결 나에게 여유로워졌어요. 이제는 마음이 설레는 일도 시작하려고요.",
      from: "코트니, 대학생",
      link: isKo
        ? "https://orwell.distancing.im/market-user-stories/courtney"
        : "https://orwell.distancing.im/market-user-stories-engs/courtney",
    },
    {
      text: "편안한 나로 있는 방법을 터득했어요. 있는 그대로의 나의 모습을 보여주니 회사 사람들과의 인간관계도 편해졌어요.",
      from: "보나, 사무직 근로자",
      link: isKo
        ? "https://orwell.distancing.im/market-user-stories/bona"
        : "https://orwell.distancing.im/market-user-stories-engs/bona",
    },
    {
      text: "하고 싶으면 하고, 가고 싶으면 가고, 먹고 싶으면 먹는 삶이 이렇게나 자유롭고 행복할 수 있다는 걸 알게 되어서 정말 기뻐요.",
      from: "허니비, 기업 교육 전문가",
      link: isKo
        ? "https://orwell.distancing.im/market-user-stories/honeybee"
        : "https://orwell.distancing.im/market-user-stories-engs/honeybee",
    },
    {
      text: "끊임없는 걱정의 악순환에서 벗어나니, 그 에너지를 더 소중한 일들에 투자할 수 있게 되었어요.",
      from: "도토리, SW 개발자",
      link: isKo
        ? "https://orwell.distancing.im/market-user-stories/dotori"
        : "https://orwell.distancing.im/market-user-stories-engs/dotori",
    },
    {
      text: "현재의 순간에서 기쁨을 알아차리는 법과, 타인의 인정에서 벗어나 스스로를 사랑하고 돌보는 법을 알게 되었어요.",
      from: "나다운, 브랜드 마케터",
      link: isKo
        ? "https://orwell.distancing.im/market-user-stories/nadaun"
        : "https://orwell.distancing.im/market-user-stories-engs/nadaun",
    },
    {
      text: "나쁜 평가를 두려워하며 아예 시작도 안하던 일들에 이제는 자신있게 도전하고 있어요.",
      from: "냠냠, 인사 관리자",
      link: isKo
        ? "https://orwell.distancing.im/market-user-stories/yumyum"
        : "https://orwell.distancing.im/market-user-stories-engs/yumyum",
    },
  ];

  return (
    <Stack direction={"column"} spacing={"16px"} sx={{ width: "100%" }}>
      <TitleWithSubtitle
        title={t_payment("디스턴싱은 우리 삶을\n변화시킵니다")}
        titleLevel="h3"
        sx={{ textAlign: "center" }}
      />
      {data.map(({ text, from, link }) => (
        <Stack
          key={text}
          direction={"column"}
          spacing="12px"
          sx={{
            width: "100%",
            borderRadius: "12px",
            backgroundColor: "card.background",
            py: "16px",
            px: "20px",
          }}
        >
          <Typography level="body-md">{t_payment(text)}</Typography>
          <Stack direction={"row"} justifyContent="space-between">
            <Typography
              startDecorator={
                <Avatar
                  alt={""}
                  color={"primary"}
                  sx={{ width: "17px", height: "17px" }}
                />
              }
            >
              {t_payment(from)}
            </Typography>
            <Link
              text={t_ui("더 보기")}
              url={link}
              level="body-sm"
              textColor="primary.solid"
              opacity={1}
              bold
              endDecorator={
                <span
                  style={{ fontSize: "inherit", marginLeft: 0 }}
                  className="material-symbols-rounded"
                >
                  arrow_forward_ios
                </span>
              }
              noUnderline
            />
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}
